import { FC } from 'react'
import cn from 'classnames'
import { ListRow } from 'src/tailwind-components/extends/List'

import s from '../../styles.module.less'

type TProps = {
  isMobile: boolean
}

const TableColumnHead: FC<TProps> = ({ isMobile }) => {
  const contactFullName = 'ФИО'
  const contactFullPhone = 'Телефон'

  return isMobile ? (
    <></>
  ) : (
    <ListRow className={cn(s.item, s.head)}>
      <div className={s.contactName}>{contactFullName}</div>
      <div className={s.phone}>{contactFullPhone}</div>
    </ListRow>
  )
}

export default TableColumnHead
